import script from "./EncodedIdField.vue?vue&type=script&setup=true&lang=js"
export * from "./EncodedIdField.vue?vue&type=script&setup=true&lang=js"

import "./EncodedIdField.vue?vue&type=style&index=0&id=36b65fdf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b65fdf"]])

export default __exports__